import { IconButton, IconButtonProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ShareOutlined } from '@mui/icons-material';
import React from 'react';

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.common.black,
}));

const ShareIconButton = (props: IconButtonProps) => {
  return (
    <StyledIconButton {...props} size="large">
      <ShareOutlined />
    </StyledIconButton>
  );
};

export default ShareIconButton;
